import styled from 'styled-components';

// Sem cabecalho de marca: este dominio nao pode referenciar Imovel Vazio.
export const Container = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  padding: 32px 16px 64px;
`;

export const Titulo = styled.div`
  margin-bottom: 24px;

  h1 {
    color: #333;
    font-size: 28px;
    font-weight: 700;
    margin: 0 0 8px;
  }

  p {
    color: #6e6e6e;
    font-size: 16px;
    line-height: 24px;
    margin: 0;
    max-width: 720px;
  }
`;

export const BarraAcoes = styled.div`
  align-items: center;
  border-bottom: 1px solid #eee;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: space-between;
  margin-bottom: 24px;
  padding-bottom: 16px;

  span {
    color: #6e6e6e;
    font-size: 15px;
  }
`;

export const Botao = styled.button`
  background: ${(props) => (props.$secundario ? '#fff' : '#ea5c1d')};
  border: 1px solid #ea5c1d;
  border-radius: 4px;
  color: ${(props) => (props.$secundario ? '#ea5c1d' : '#fff')};
  cursor: pointer;
  font-size: ${(props) => (props.$compacto ? '12px' : '15px')};
  font-weight: 500;
  padding: ${(props) => (props.$compacto ? '6px 10px' : '10px 20px')};
  transition: opacity 0.2s;
  white-space: nowrap;

  &:hover:not(:disabled) {
    opacity: 0.85;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const Grade = styled.div`
  display: grid;
  gap: 10px;
  /* 240px cabe 4 colunas no container de 1180px; abaixo disso o auto-fill
     vai reduzindo sozinho ate 1 coluna no celular */
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
`;

export const Cartao = styled.div`
  border: 1px solid #eee;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  img {
    cursor: zoom-in;
    display: block;
    height: auto;
    width: 100%;
  }

  .placeholder {
    align-items: center;
    background: #fafafa;
    color: #a0a0a0;
    display: flex;
    font-size: 14px;
    justify-content: center;
    min-height: 260px;
    padding: 16px;
    text-align: center;
  }

  .rodape {
    align-items: center;
    border-top: 1px solid #eee;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    justify-content: space-between;
    /* as fotos tem proporcoes diferentes; sem isto o rodape de cada card
       para numa altura, e a linha fica desalinhada */
    margin-top: auto;
    padding: 8px;
  }

  .rodape a {
    color: #6e6e6e;
    font-size: 12px;
    text-decoration: underline;
    white-space: nowrap;
  }
`;

export const Lupa = styled.div`
  align-items: center;
  background: rgba(0, 0, 0, 0.85);
  bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  left: 0;
  padding: 24px 16px;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1000;

  img {
    background: #fff;
    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.5);
    max-height: calc(100vh - 140px);
    max-width: min(560px, 100%);
    object-fit: contain;
  }

  .acoes {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: center;
  }

  .fechar {
    background: none;
    border: none;
    color: #fff;
    cursor: pointer;
    font-size: 32px;
    line-height: 1;
    padding: 8px 14px;
    position: absolute;
    right: 8px;
    top: 8px;
  }
`;

export const Aviso = styled.div`
  background: #fff8f4;
  border-left: 4px solid #ea5c1d;
  color: #6e6e6e;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 24px;
  padding: 14px 18px;
`;
